import clsx from "classnames";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";
import useNCPValues from "hooks/useNCPValues";

export const MultiValues = ({
  className,
  customBulletPoints,
  content,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const post = useNCPValues();

  const items = customBulletPoints.length > 0 ? customBulletPoints : post;
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section className={clsx(className, styles.root)}>
        <div className="outer-wrapper">
          <Container>
            {content && <div className={`content`} dangerouslySetInnerHTML={{ __html: content }} />}
            <div className="wrapper">
              {items.map((item, index) => (
                <div className="column mb-3" key={index}>
                  <div className="d-flex gap-3">
                    {item.imgIcon?.url && (
                      <img
                        className="bullet-icon"
                        src={item.imgIcon.url}
                        alt={item.imgIcon.alt || "icon"}
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    <div className="d-flex flex-column">
                      <div className="post-title">{item.title}</div>
                      {item.content && (
                        <div
                          className="post-content"
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default MultiValues;
